<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" [title]='vm.title' [canGoBack]="true" [canRefresh]="true" (refreshClick)="refreshPage()">
    </app-page-header>

    <!-- content -->
    <div class="row" *ngIf="!vm.workingText && !vm.errorText">
        <div class="col-md-12 pt-3">

            <mdb-card class="mb-3" cascade="true" narrower="true">
                <!-- todo... add header -->
                <mdb-card-body cascade="true" class="py-2">
                    <div class="row">
                        <div class="col-md-12">
                            
                            <!-- working / error -->
                            <div class="text-center" *ngIf="!vm.gridVm">
                                <span>Loading Grid...</span>
                            </div>
                            
                            <!-- show grid -->
                            <div *ngIf="vm.gridVm as gvm">
                                <app-table-data [hostOptions]="gvm.hostOptions" [layoutOptions]="gvm.layoutOptions" [allowEmail]="false" [allowExport]="true" [allowReload]="true"></app-table-data>                            
                            </div>

                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>

            <!-- disabled for now -->
            <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'" *ngIf="1 == 2">
                
                <!-- grid -->
                <mdb-tab heading="Query">
                    
                    <!-- working / error -->
                    <div class="text-center" *ngIf="!vm.gridVm">
                        <span>Loading Grid...</span>
                    </div>
                    
                    <!-- show grid -->
                    <div *ngIf="vm.gridVm as gvm">
                        <app-table-data [hostOptions]="gvm.hostOptions" [layoutOptions]="gvm.layoutOptions" [allowEmail]="false" [allowExport]="false"></app-table-data>                            
                    </div>
                </mdb-tab>
                
                <!-- map -->
                <mdb-tab heading="Map" (select)="onSelectMap(vm)" *ngIf="vm.mapVm">
                    
                    <!-- working / error -->
                    <div class="text-center" *ngIf="!vm.mapVm">
                        <span>Loading Map...</span>
                    </div>

                    <!-- show map -->
                    <div *ngIf="vm.mapVm as mvm">
                        <div class="row">
                            <div class="col-md-12 pb-3">

                                <div *ngIf="mvm.workingText" class="text-center">
                                    <span>{{mvm.workingText}}</span>
                                </div>
                                <div *ngIf="mvm.errorText" class="text-center text-danger">
                                    <span>{{mvm.errorText}}</span>
                                </div>
                                
                                <!-- content -->
                                <div *ngIf="!mvm.workingText && !mvm.errorText">
                                    <div *ngIf="mvm.disclaimerText" class="alert alert-warning" role="alert">{{mvm.disclaimerText}}</div>

                                    <agm-map *ngIf="mvm.centerPoint" [zoom]="5" [usePanning]="true" [latitude]="mvm.centerPoint.latitude" [longitude]="mvm.centerPoint.longitude" style="height: 1280px">
                                        <agm-marker *ngFor="let marker of mvm.markers" 
                                            [latitude]="marker.latitude" [longitude]="marker.longitude"
                                            [title]="marker.title"
                                        >
                                            <agm-info-window *ngIf="marker.details">
                                                <div *ngFor="let d of marker.details" class="pb-3">
                                                    <h5 class="mb-0">{{d.title}}</h5>
                                                    <hr class="mt-0 mb-2"/>
                                                    <div *ngFor="let r of d.rows">
                                                        <b>{{r.title}}:</b>
                                                        <span class="pl-1">{{r.value}}</span>    
                                                    </div>
                                                </div>
                                            </agm-info-window>
                                        </agm-marker>
                                    </agm-map>
    
                                    <div *ngIf="!mvm.centerPoint" class="text-center">
                                        No trips in process
                                    </div>
    
                                </div>
    
                            </div>
                        </div>    
                    </div>
                </mdb-tab>

            </mdb-tabset>
        </div>
    </div>

</div>